import { LOCAL_STORAGE_TOKENS } from "../utils/constants";
import { apiMapper } from "./ApiMapper";
import axios from "./axios";
const { localKey_access, localKey_refresh } = LOCAL_STORAGE_TOKENS;
const UserAPI = {
  Register: (data) => {
    return axios.post(apiMapper.users.register, data);
  },
  Login: (data) => {
    let endPoint = "";
    return axios.post(endPoint, data).then((response) => {
      localStorage.setItem(localKey_refresh, response.data.refresh);
      localStorage.setItem(localKey_access, response.data.access);
      return response;
    });
  },
  ForgotPassword: (data) => {
    return axios.post(apiMapper.users.forgotPassword, data);
  },
  PasswordReset: (data) => {
    return axios.post(apiMapper.users.passwordReset, data);
  },
  Logout: async (apiCall) => {
    const clearTokens = () => {
      localStorage.removeItem(localKey_refresh);
      localStorage.removeItem(localKey_access);
    };

    if (!apiCall) {
      clearTokens();
      return Promise.resolve();
    }

    const data = { refresh_token: localStorage.getItem(localKey_refresh) };
    return axios.post(apiMapper.users.logout, data).then((response) => {
      clearTokens();
      return response;
    });
  },
  GetUserDetails: (axiosPrivate) => {
    return axiosPrivate.get(apiMapper.users.getUserDetails);
  },
  UpdateUserDetails: (axiosPrivate, data) => {
    return axiosPrivate.patch(apiMapper.users.updateUserDetails, data);
  },
  ChangePassword: (axiosPrivate, data) => {
    return axiosPrivate.post(apiMapper.users.changePassword, data);
  },
  Settings: (axiosPrivate, data) => {
    return axiosPrivate.patch(apiMapper.users.settings, data);
  },
};

export default UserAPI;
